export class ProjectUsersTagsReadModel
{
     ProjectId: number;
     Tags: string[]
}

export class ProjectsPageReadModel
{
    WorkspaceId: number;
    WorkspaceName: string;
    Projects: ProjectReadModel[];
}

export class ProjectTemplateDownloadPageReadModel 
{
    ProjectId: number;
    ProjectTemplateLinkId: number;
    Workspaces: WorkspaceReadModel[];
}

export class WorkspaceReadModel 
{
    Id: number;
    Name: string;
}

export class ProjectReadModel
{
    WorkspaceId: number;

    ProjectId: number;
    Name: string;
    Description: string;
    Type: string;
    Created: Date = null;
    LastActivity: Date = null;
}

export class ProjectTemplateLinksReadModel
{
    WorkspaceId: number;
    ProjectId: number;
    ProjectName: string;
    Links: ProjectTemplateLinkReadModel[];
    BaseUrl: string;
}

export class ProjectTemplateLinkReadModel 
{
    Id: number;
    Created: Date;
    Modified: Date;
    Name: string;
    AccessKey: string;
    AccessUrl: string;
    Views: number;
    Downloads: number;
}
